<div class="forget-pass-container">
  <div *ngIf="!showFeedBack" class="email-container">
    <form autocomplete="off" method="POST" class="form-recover" [formGroup]="recoverForm">
      <h1 class="title">¿Has olvidado tu contraseña?</h1>
      <p class="information">Te enviaremos un email para restablecer tu contraseña:</p>
      <div class="input-control-error">
        <input type="text" id="userId"
          [ngClass]="{'error-input': recoverForm.controls.email.value && recoverForm.controls.email.invalid &&
              recoverForm.controls.email.touched || !recoverForm.controls.email.value && recoverForm.controls.email.touched}"
          formControlName="email" class="input-search" name="" placeholder="Introduce tu email">
        <div class="div-error"
          *ngIf="recoverForm.controls.email.value && recoverForm.controls.email.invalid && recoverForm.controls.email.touched">
          {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
        </div>
        <div class="div-error" *ngIf="!recoverForm.controls.email.value && recoverForm.controls.email.touched"
          [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
        </div>
      </div>
      <div class="btn-container">
        <button class="sign-in first" id="signInId" [ngClass]="{'ready': recoverForm.valid }" *ngIf="!showProgress"
          (click)="sendMail()">Iniciar Sesión</button>
        <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="showProgress"
          mode="indeterminate">
        </mat-progress-bar>
      </div>
      <p class="back-view" (click)="goToUrl('multi-signin/main')">¡Ya me acuerdo! Iniciar Sesión</p>
    </form>
  </div>
  <div *ngIf="showFeedBack" class="feedback">
    <img class="paper" src="./assets/temporals/paper_plane.png" alt="">
    <h1 class="title feedback_">¡Listo! Revisa tu email</h1>
    <p class="information feedback_">Te hemos enviado un enlace para que puedas restablecer tu contraseña.</p>
    <div class="btn-container">
      <button class="sign-in back-signin" id="backSignIn" (click)="goToUrl('multi-signin/main')">Ir a Akana</button>
    </div>
  </div>
</div>
